module.exports = __webpack_public_path__ + "static/img/sort-back4.2bdc97f2.png";